var forEach = function (array, callback, scope) {
  for (var i = 0; i < array.length; i++) {
    callback.call(scope, array[i], i);
  }
};

var Wayward = Wayward || {};
const API_URL = "https://backend-api.team-c82.workers.dev/v1";
const CPO_ACCESSORY_LABELS = {
  "coiled-cables": "Coiled Aviator Cables",
  "kb-tools": "Tools & Misc",
  "wrist-rest": "Wrist Rest",
  "numpads": "Numpads",
  "deskmats": "Deskmats",
  "artisan-caps": "Artisan Keycaps",
};

function formatCpoCartLabel(label, value) {
  if (!label || label === value) return value;
  return `${label} (${value})`;
}

class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector("cart-notification");
  }

  async onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);


    console.log("submitted", Wayward)

    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute("disabled", true);
    submitButton.classList.add("loading");

    const formData = JSON.parse(serializeForm(this.form));
    const body = {
      ...formData,
      sections: this.cartNotification
        .getSectionsToRender()
        .map((section) => section.id),
      sections_url: window.location.pathname,
    };

    // Wayward product_options
    if (
      document.querySelector("#product_options") !== undefined &&
      Wayward &&
      Wayward.isCustom
    ) {
      const cart_options = {
        _components: "",
      };
      const api_options = {};
      const selected_accessories = {};

      const fields = document.querySelectorAll(
        "#product_options input[type='checkbox']:checked, #product_options input[type='radio']:checked, #product_options select > option:checked"
      );
      const shipping = document.querySelector(
        "#submit-button-po-shipping-notice"
      )?.innerText;

      forEach(fields, (input) => {
        const name = input.getAttribute("name");
        if (name) {
          const value = input.value;
          const label =
            input.getAttribute("label") || input.getAttribute("title") || value;
          if (name && value) {
            cart_options["_components"] += `${name}=${value}&`;
          }
          if (CPO_ACCESSORY_LABELS[name]) {
            if (!Array.isArray(selected_accessories[name])) {
              selected_accessories[name] = [];
            }
            selected_accessories[name].push(formatCpoCartLabel(label, value));
          }
          if (!Array.isArray(cart_options[name])) {
            cart_options[name] = [label];
          } else {
            cart_options[name].push(label);
          }
          if (!Array.isArray(api_options[name])) {
            api_options[name] = [value];
          } else {
            api_options[name].push(value);
          }
        }
      });
      const params = new URLSearchParams(window.location.search);
      const cartItemId = params.get("edit");

      const productImg = document.querySelector(
        ".product__media-item > div.no-js-hidden img"
      );

      fetch(`${API_URL}/handlers/add-to-cart`, {
        mode: "cors",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          product_slug: Wayward.product.handle,
          cpo: api_options,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          console.log('res', res)
          if ((res.success = false)) return console.error(res.message);
          const properties = Object.assign({}, res.data.cartOptions || {});
          Object.entries(selected_accessories).forEach(([name, labels]) => {
            if (labels.length) {
              properties[CPO_ACCESSORY_LABELS[name]] = labels.join(", ");
            }
          });
          if (shipping !== undefined) {
            properties["Shipping"] = shipping.replace(
              "Estimated shipping",
              "Est"
            );
          }

          fetch(`${routes.cart_add_url}`, {
            ...fetchConfig("javascript"),
            body: JSON.stringify({
              ...body,
              id: res.data.productVariant.id.replace(
                "gid://shopify/ProductVariant/",
                ""
              ),
              properties,
            }),
          })
            .then((response) => response.json())
            .then((parsedState) => {
              this.cartNotification.renderContents(parsedState);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("disabled");
            });
        })
        .catch((e) => {
          console.error(e);
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("disabled");
        });
    } else {
      fetch(`${routes.cart_add_url}`, {
        ...fetchConfig("javascript"),
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((parsedState) => {
          this.cartNotification.renderContents(parsedState);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("disabled");
        });
    }
  }
}

customElements.define("product-form", ProductForm);
